import ApiService from '@/services/core/api.service'

const BorrowingService = {
  async get (query = '') {
    return ApiService.get(`admin/borrowings?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/borrowings', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/borrowings/${payload.id}`, payload)
  }
}

export default BorrowingService
